import React from 'react';
import { Icon } from './Icon.js';
export const IconToggle2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m7.5,1.5h-3C2.019,1.5,0,3.519,0,6s2.019,4.5,4.5,4.5h3c2.481,0,4.5-2.019,4.5-4.5S9.981,1.5,7.5,1.5Zm-3,7c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5,2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconToggle2Fill12.js.map